import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE} from 'util/constants';

const
    name = 'totalSpending',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.totalSpending.endpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
        transformResultsFn: json => [json],
        parseParameters:    params => ({
            start_date: Math.floor(params.startDate / TIMESTAMP_MULTIPLY),
            end_date:   Math.floor(params.endDate / TIMESTAMP_MULTIPLY),
            by:         params.by === 'costCenter' ? 'cost_center' :
                params.by === 'productArea' ? 'product_area' : params.by,
            entity: params.items.join(',')
        })
    });

exports.createParams = (by, period, items) => ({
    ...period,
    items: items
        .filter(item => item)
        .map(({options:{id}}) => id),
    by
});

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/totalSpending.js